import _ from "underscore";

import { Card, ListItem, ListItemAvatar } from "@material-ui/core";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import { DatePicker } from "@material-ui/pickers/DatePicker";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import AutomaticMatch from "@material-ui/icons/BrightnessAuto";
import ManualMatch from "@material-ui/icons/PanTool";
import DeleteMatch from "@material-ui/icons/Delete";
import Avatar from "@material-ui/core/Avatar";

import { numberWithSpaces } from "../../../../utilities/formaters";

import { accountingConnector } from "../../../../services/accounting/connector";

const DepositsContent = ({
  matchedDeposits,
  sumToTransferDeposits,
  accounting,
  confirmDateDeposit,
  setConfirmDateDeposit,
  toggleMatchedPaymentSendingFlag,
  approveDepositOrder,
}) => {
  return (
    <div className="content-padding">
      <Card>
        <CardHeader
          title={
            "Deposit payments (" +
            numberWithSpaces(sumToTransferDeposits) +
            "kr)"
          }
        />
        <CardContent>
          <DatePicker
            inputVariant="outlined"
            className="small-datepicker"
            value={confirmDateDeposit}
            onChange={setConfirmDateDeposit}
            helperText="Confirm date"
            label="Confirm date"
          />
          <Button
            variant="contained"
            color="primary"
            id="confirmMatched"
            onClick={sendMatchedDeposits}
          >
            Confirm matched deposits
          </Button>
          <List>
            {matchedDeposits.map((item, index) => {
              let isAutomatch = !(
                accounting.matchedDeposits.manualMatchData &&
                accounting.matchedDeposits.manualMatchData[item.Id]
              );
              let isRemovedFromSending =
                accounting.matchedDeposits.data[item.Id].RemoveFromSending;

              let icon = isAutomatch ? <AutomaticMatch /> : <ManualMatch />;
              if (isRemovedFromSending) icon = <DeleteMatch />;

              let backgroundColor = isAutomatch
                ? "rgb(81, 211, 130)"
                : "#1236ff";

              return (
                <ListItem key={index} disabled={true}>
                  <ListItemAvatar>
                    <Avatar backgroundColor={backgroundColor} icon={icon} />
                  </ListItemAvatar>
                  <div className="row">
                    <div className="col-md-6">
                      Payment Id: {item.Id} <br />
                      Ref code: <strong>{item.RefCode} </strong>
                      <br />
                      Amount:{" "}
                      <strong>{numberWithSpaces(item.Amount.Amount)} </strong>
                      <br />
                      Matched with{" "}
                      {accounting.matchedDeposits.data[item.Id].RefCode}
                    </div>
                    <div className="col-md-6">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={toggleMatchedPaymentSendingFlag.bind(
                          this,
                          "deposit",
                          item.Id,
                        )}
                      >
                        Toggle deposit sending
                      </Button>
                    </div>
                  </div>
                </ListItem>
              );
            })}
          </List>
        </CardContent>
      </Card>
    </div>
  );

  function sendMatchedDeposits() {
    for (let match in accounting.matchedDeposits.data) {
      if (!accounting.matchedDeposits.data[match].RemoveFromSending) {
        // eslint-disable-next-line no-undef
        const deposit = _.find(props.deposits.data, (item) => {
          return accounting.matchedDeposits.data[match].RefCode === item.Id;
        });

        let depositPayment = _.find(accounting.depositPayments.data, (item) => {
          return item.Id === match;
        });

        approveDepositOrder(
          deposit.Id,
          deposit.AccountId,
          deposit.DepotId,
          depositPayment.Id,
          depositPayment.Amount.Amount,
          confirmDateDeposit,
        );
      }
    }
  }
};

export default accountingConnector(DepositsContent);
